var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, isValidElement, useEffect } from "react";
import classNames from "classnames";
import AntTabs from "antd/es/tabs";
import { mapChildren } from "../helpers";
import { useWindowSize } from "../hooks/useWindowSize";
import Select from "../Select";
import HiddenText from "../HiddenText";
const MOBILE_BREAKPOINT = 600;
const Tabs = (_a) => {
    var { activeKey, defaultActiveKey, children, className, destroyInactiveTabPane = false, showAllTabPanesOnPrint = false, tabBarA11yLabel = "Change tab", onChange } = _a, props = __rest(_a, ["activeKey", "defaultActiveKey", "children", "className", "destroyInactiveTabPane", "showAllTabPanesOnPrint", "tabBarA11yLabel", "onChange"]);
    const [innerActiveKey, setInnerActiveKey] = useState(activeKey || defaultActiveKey);
    const { width } = useWindowSize();
    useEffect(() => {
        setInnerActiveKey(activeKey);
    }, [activeKey]);
    const isMobile = width !== undefined && width < MOBILE_BREAKPOINT;
    const onTabChange = (key) => {
        setInnerActiveKey(key);
        if (onChange)
            onChange(key);
    };
    const renderMobileTabBar = ({ activeKey, id, panes }) => (React.createElement("div", null,
        React.createElement(HiddenText, null,
            React.createElement("label", { htmlFor: id }, tabBarA11yLabel)),
        React.createElement(Select, { id: id, value: activeKey, onChange: (key) => onTabChange(key) }, mapChildren(panes, (el) => {
            if (!isValidElement(el) || el.type !== TabPaneType)
                return;
            const key = el.key;
            return (React.createElement(Select.Option, { value: key, key: key, id: `${id}-tab-${key}`, "aria-controls": `${id}-panel-${key}` }, el.props.tab));
        }))));
    return (React.createElement(AntTabs, Object.assign({ activeKey: innerActiveKey, className: classNames("gerudo-tabs", className, { "show-all-on-print": showAllTabPanesOnPrint }), size: "large", destroyInactiveTabPane: destroyInactiveTabPane && !showAllTabPanesOnPrint, onTabClick: onTabChange, renderTabBar: isMobile ? renderMobileTabBar : undefined }, props), children));
};
const TabPane = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement(AntTabs.TabPane, Object.assign({ className: classNames("gerudo-tabs-tab-pane", className) }, props));
};
Tabs.TabPane = TabPane;
// This is stupid but is a workaround for ReactElement type checks when using react-hot-loader
// https://github.com/gaearon/react-hot-loader/issues/304
const TabPaneType = (React.createElement(TabPane, { key: "whatever" })).type;
export default Tabs;
export { Tabs };
//# sourceMappingURL=Tabs.js.map